(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gm-faq-lp"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFaqLp(section) {
    section.querySelectorAll('.gm-faq-lp__trigger').forEach(function (btn) {
      var body = document.getElementById(btn.getAttribute('aria-controls'));
      if (!body) return;

      body.setAttribute('aria-hidden', 'true');

      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        body.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      });
    });
  }

  document.querySelectorAll('.gm-faq-lp').forEach(initFaqLp);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.gm-faq-lp');
      if (section) initFaqLp(section);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm-ingredients"] && !Shopify.designMode) return;
  try {
    
(function () {
  var BREAKPOINT  = 767;
  var AUTO_DELAY  = 3500;
  var RESUME_WAIT = 6000;

  function init(section) {
    var track   = section.querySelector('.gm-ingredients__track');
    var slides  = Array.prototype.slice.call(section.querySelectorAll('.gm-ingredients__slide'));
    var prevBtn = section.querySelector('.gm-ingredients__arrow--prev');
    var nextBtn = section.querySelector('.gm-ingredients__arrow--next');

    if (!track || !slides.length) return;

    var current     = 0;
    var total       = slides.length;
    var autoTimer   = null;
    var resumeTimer = null;
    var isMobile    = false;

    /* Activate first slide immediately */
    slides[0].classList.add('is-active');

    function render(idx) {
      slides[current].classList.remove('is-active');
      current = ((idx % total) + total) % total;
      slides[current].classList.add('is-active');
    }

    function startAuto() {
      clearInterval(autoTimer);
      autoTimer = setInterval(function () { render(current + 1); }, AUTO_DELAY);
    }

    function pause() {
      clearInterval(autoTimer);
      clearTimeout(resumeTimer);
      autoTimer = null;
    }

    function scheduleResume() {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(startAuto, RESUME_WAIT);
    }

    prevBtn.addEventListener('click', function () {
      render(current - 1);
      pause();
      scheduleResume();
    });

    nextBtn.addEventListener('click', function () {
      render(current + 1);
      pause();
      scheduleResume();
    });

    /* Swipe */
    var touchStartX = 0;
    var touchStartY = 0;
    var isSwipe     = false;

    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isSwipe     = false;
      pause();
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      var dx = Math.abs(e.touches[0].clientX - touchStartX);
      var dy = Math.abs(e.touches[0].clientY - touchStartY);
      if (dx > dy && dx > 8) isSwipe = true;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (isSwipe) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 36) render(current + (diff > 0 ? 1 : -1));
      }
      scheduleResume();
    }, { passive: true });

    /* Pause when out of viewport */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && isMobile) {
          startAuto();
        } else {
          pause();
        }
      });
    }, { threshold: 0.4 });

    observer.observe(section);

    function onResize() {
      isMobile = window.innerWidth <= BREAKPOINT;
      if (isMobile) {
        if (!autoTimer) startAuto();
      } else {
        pause();
      }
    }

    window.addEventListener('resize', onResize, { passive: true });
    onResize();
  }

  document.querySelectorAll('.gm-ingredients[id]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm-kit-builder-lp"] && !Shopify.designMode) return;
  try {
    
(function () {
  function parsePrice(raw) {
    if (!raw) return 0;
    var s = String(raw).replace(/[^\d,\.]/g, '');
    if (s.indexOf(',') > s.indexOf('.') && s.indexOf(',') !== -1) {
      s = s.replace(/\./g, '').replace(',', '.');
    }
    return parseFloat(s) || 0;
  }

  function formatBRL(num) {
    return 'R$ ' + num.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+,)/g, '$1.');
  }

  function KitBuilder(sectionId) {
    var el = document.getElementById('gm-kb-' + sectionId);
    var configEl = document.getElementById('gm-kb-config-' + sectionId);
    if (!el || !configEl) return;

    var cfg;
    try { cfg = JSON.parse(configEl.textContent); } catch (e) { return; }
    if (!cfg.kits || !cfg.kits.length) return;

    var state = {
      kitIndex: 0,
      imgIndex: 0,
      qty: cfg.qtyMin || 1
    };

    var mainImg = el.querySelector('[data-main-image]');
    var thumbsWrap = el.querySelector('[data-thumbs]');
    var kitBtns = el.querySelectorAll('[data-kit-index]');
    var qtyBtns = el.querySelectorAll('[data-qty]');
    var priceEl = el.querySelector('[data-price]');
    var priceUnitEl = el.querySelector('[data-price-unit]');
    var ctaBtn = el.querySelector('[data-checkout-btn]');
    var galleryPrev = el.querySelector('[data-gallery-prev]');
    var galleryNext = el.querySelector('[data-gallery-next]');
    var badgeEl = el.querySelector('[data-kit-badge]');

    function getValidImages() {
      return (cfg.kits[state.kitIndex].images || []).filter(Boolean);
    }

    function getValidThumbs() {
      return (cfg.kits[state.kitIndex].thumbnails || []).filter(Boolean);
    }

    function renderThumbs() {
      if (!thumbsWrap) return;
      thumbsWrap.innerHTML = '';
      getValidThumbs().forEach(function (src, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gm-kb__thumb' + (i === state.imgIndex ? ' is-active' : '');
        btn.dataset.thumbIndex = i;
        var img = document.createElement('img');
        img.src = src;
        img.width = 80;
        img.height = 80;
        img.loading = 'lazy';
        btn.appendChild(img);
        btn.addEventListener('click', function () {
          state.imgIndex = i;
          updateGallery();
        });
        thumbsWrap.appendChild(btn);
      });
    }

    function updateGallery() {
      var images = getValidImages();
      if (mainImg && images.length) {
        if (mainImg.tagName === 'IMG') {
          mainImg.src = images[state.imgIndex] || images[0];
          mainImg.alt = cfg.kits[state.kitIndex].name || '';
        }
      }

      var kit = cfg.kits[state.kitIndex];
      if (badgeEl) {
        if (kit.badge) {
          badgeEl.textContent = kit.badge;
          badgeEl.style.display = '';
        } else {
          badgeEl.style.display = 'none';
        }
      }

      renderThumbs();
    }

    function updatePrice() {
      var kit = cfg.kits[state.kitIndex];
      var unit = parsePrice(kit.priceOnetime);
      var discountFixed = kit.discounts ? (parseFloat(kit.discounts[String(state.qty)]) || 0) : 0;
      var originalEl = el.querySelector('[data-price-original]');
      var savingsEl = el.querySelector('[data-savings]');
      var savingsAmountEl = el.querySelector('[data-savings-amount]');

      if (priceEl) {
        if (unit) {
          var originalTotal = unit * state.qty;
          if (discountFixed > 0) {
            var discountedTotal = Math.max(0, originalTotal - discountFixed);
            priceEl.textContent = formatBRL(discountedTotal);
            if (originalEl) { originalEl.textContent = formatBRL(originalTotal); originalEl.style.display = ''; }
            if (savingsEl) { savingsEl.style.display = ''; }
            if (savingsAmountEl) { savingsAmountEl.textContent = formatBRL(discountFixed); }
          } else {
            priceEl.textContent = formatBRL(originalTotal);
            if (originalEl) originalEl.style.display = 'none';
            if (savingsEl) savingsEl.style.display = 'none';
          }
        } else {
          priceEl.textContent = '—';
          if (originalEl) originalEl.style.display = 'none';
          if (savingsEl) savingsEl.style.display = 'none';
        }
      }

      if (priceUnitEl && unit && state.qty > 1) {
        var totalFinal = discountFixed > 0 ? Math.max(0, unit * state.qty - discountFixed) : unit * state.qty;
        priceUnitEl.textContent = formatBRL(totalFinal / state.qty) + ' cada';
      } else if (priceUnitEl) {
        priceUnitEl.textContent = '';
      }
    }

    function renderStars(starsEl, rating) {
      var filled = Math.floor(rating);
      var ns = 'http://www.w3.org/2000/svg';
      starsEl.innerHTML = '';
      for (var i = 1; i <= 5; i++) {
        var svg = document.createElementNS(ns, 'svg');
        svg.setAttribute('class', 'gm-kb__star');
        svg.setAttribute('width', '22');
        svg.setAttribute('height', '22');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('fill', i <= filled ? 'var(--gm-kb-star)' : 'none');
        svg.setAttribute('stroke', 'var(--gm-kb-primary)');
        svg.setAttribute('stroke-width', '1.5');
        svg.setAttribute('stroke-linejoin', 'round');
        var path = document.createElementNS(ns, 'path');
        path.setAttribute('d', 'M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z');
        svg.appendChild(path);
        starsEl.appendChild(svg);
      }
    }

    function updateRating() {
      var kit = cfg.kits[state.kitIndex];
      var starsEl = el.querySelector('[data-kit-stars]');
      var labelEl = el.querySelector('[data-kit-rating-label]');
      if (starsEl) renderStars(starsEl, kit.rating || 0);
      if (labelEl) {
        var r = kit.rating || 0;
        var c = kit.ratingCount || 0;
        if (r > 0) {
          var countStr = c > 0 ? ' (' + c.toLocaleString('pt-BR') + ')' : '';
          labelEl.textContent = r.toFixed(1) + '/5.0' + countStr;
        } else {
          labelEl.textContent = '';
        }
      }
    }

    function fetchJudgeMeRatings() {
      cfg.kits.forEach(function(kit, index) {
        if (!kit.productHandle || !kit.productId || !cfg.shopDomain) return;
        var url = 'https://judge.me/api/v1/widgets/preview_badge'
          + '?shop_domain=' + encodeURIComponent(cfg.shopDomain)
          + '&platform=shopify'
          + '&handle=' + encodeURIComponent(kit.productHandle)
          + '&external_id=' + kit.productId;
        fetch(url)
          .then(function(res) { return res.text(); })
          .then(function(html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var badge = tmp.querySelector('.jdgm-prev-badge');
            if (!badge) return;
            var score = parseFloat(badge.getAttribute('data-score')) || 0;
            var count = parseInt(badge.getAttribute('data-number-of-reviews')) || 0;
            if (!score) return;
            cfg.kits[index].rating = Math.round(score * 10) / 10;
            cfg.kits[index].ratingCount = count;
            if (index === state.kitIndex) updateRating();
          })
          .catch(function() {});
      });
    }

    function escapeHtml(str) {
      return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }

    function updateDescription() {
      var kit = cfg.kits[state.kitIndex];

      var descEl = el.querySelector('[data-kit-description]');
      if (descEl) {
        var desc = kit.description || '';
        descEl.textContent = desc;
        descEl.style.display = desc ? '' : 'none';
      }

      var benefitsEl = el.querySelector('[data-kit-benefits]');
      if (benefitsEl) {
        var benefits = (kit.benefits || []).filter(Boolean);
        if (benefits.length) {
          benefitsEl.innerHTML = benefits.map(function(b) {
            return '<li class="gm-kb__benefit"><svg class="gm-kb__check" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg><span>' + escapeHtml(b) + '</span></li>';
          }).join('');
          benefitsEl.style.display = '';
        } else {
          benefitsEl.innerHTML = '';
          benefitsEl.style.display = 'none';
        }
      }

      var featuresEl = el.querySelector('[data-kit-features]');
      if (featuresEl) {
        var features = (kit.features || []).filter(Boolean);
        if (features.length) {
          featuresEl.innerHTML = features.map(function(f) {
            return '<span class="gm-kb__feature">' + escapeHtml(f) + '</span>';
          }).join('');
          featuresEl.style.display = '';
        } else {
          featuresEl.innerHTML = '';
          featuresEl.style.display = 'none';
        }
      }

      updateRating();
    }

    function updateUI() {
      kitBtns.forEach(function (btn) {
        btn.classList.toggle('is-active', parseInt(btn.dataset.kitIndex) === state.kitIndex);
      });
      qtyBtns.forEach(function (btn) {
        btn.classList.toggle('is-active', parseInt(btn.dataset.qty) === state.qty);
      });
      updateGallery();
      updatePrice();
      updateDescription();
    }

    kitBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.kitIndex = parseInt(btn.dataset.kitIndex);
        state.imgIndex = 0;
        updateUI();
      });
    });

    qtyBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.qty = parseInt(btn.dataset.qty);
        updateUI();
      });
    });

    if (galleryPrev) {
      galleryPrev.addEventListener('click', function () {
        var imgs = getValidImages();
        if (!imgs.length) return;
        state.imgIndex = (state.imgIndex - 1 + imgs.length) % imgs.length;
        updateGallery();
      });
    }

    if (galleryNext) {
      galleryNext.addEventListener('click', function () {
        var imgs = getValidImages();
        if (!imgs.length) return;
        state.imgIndex = (state.imgIndex + 1) % imgs.length;
        updateGallery();
      });
    }

    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        var kit = cfg.kits[state.kitIndex];
        var variantId = kit.variantIdOnetime;
        var discountCode = (kit.coupons && kit.coupons[String(state.qty)]) || '';

        if (!variantId) {
          console.warn('[gm-kit-builder] Produto não configurado para este kit.');
          return;
        }

        ctaBtn.disabled = true;
        ctaBtn.classList.add('is-loading');

        fetch('/cart/clear.js', { method: 'POST' })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{ id: parseInt(variantId, 10), quantity: state.qty }]
              })
            });
          })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Erro ao adicionar'); });
            if (discountCode) {
              var discountUrl = 'https://' + cfg.shopDomain + '/discount/' + encodeURIComponent(discountCode) + '?redirect=/checkout';
              window.location.href = discountUrl;
              return;
            }
            window.location.href = '/checkout';
          })
          .catch(function (err) {
            console.error('[gm-kit-builder] Erro no checkout:', err);
            ctaBtn.disabled = false;
            ctaBtn.classList.remove('is-loading');
          });
      });
    }

    updateUI();
    fetchJudgeMeRatings();
  }

  function processQueue() {
    var queue = window.__gmKbQueue || [];
    queue.forEach(function (id) { new KitBuilder(id); });
    window.__gmKbQueue = { push: function (id) { new KitBuilder(id); } };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processQueue);
  } else {
    processQueue();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gm-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  var AUTO_DELAY  = 4000;
  var RESUME_WAIT = 6000;

  function init(section) {
    var track  = section.querySelector('.gm-testimonials__track');
    var slides = Array.prototype.slice.call(section.querySelectorAll('.gm-testimonials__slide'));

    if (!track || !slides.length) return;

    var current     = 0;
    var total       = slides.length;
    var autoTimer   = null;
    var resumeTimer = null;
    var isMobile    = false;

    slides[0].classList.add('is-active');

    function render(idx) {
      slides[current].classList.remove('is-active');
      current = ((idx % total) + total) % total;
      slides[current].classList.add('is-active');
    }

    function startAuto() {
      clearInterval(autoTimer);
      autoTimer = setInterval(function () { render(current + 1); }, AUTO_DELAY);
    }

    function pause() {
      clearInterval(autoTimer);
      clearTimeout(resumeTimer);
      autoTimer = null;
    }

    function pauseAndResume() {
      pause();
      resumeTimer = setTimeout(startAuto, RESUME_WAIT);
    }

    /* Click: metade esquerda = anterior, metade direita = próximo */
    track.addEventListener('click', function (e) {
      var rect = track.getBoundingClientRect();
      var mid  = rect.left + rect.width / 2;
      render(e.clientX < mid ? current - 1 : current + 1);
      pauseAndResume();
    });

    /* Swipe support */
    var touchStartX = 0;
    var touchStartY = 0;
    var isSwipe     = false;

    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isSwipe     = false;
      pause();
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      var dx = Math.abs(e.touches[0].clientX - touchStartX);
      var dy = Math.abs(e.touches[0].clientY - touchStartY);
      if (dx > dy && dx > 8) isSwipe = true;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (isSwipe) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 36) render(current + (diff > 0 ? 1 : -1));
      }
      resumeTimer = setTimeout(startAuto, RESUME_WAIT);
    }, { passive: true });

    /* Pause when out of viewport */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && isMobile) {
          startAuto();
        } else {
          pause();
        }
      });
    }, { threshold: 0.4 });

    observer.observe(section);

    function onResize() {
      isMobile = window.innerWidth <= 767;
      if (isMobile) {
        if (!autoTimer) startAuto();
      } else {
        pause();
      }
    }

    window.addEventListener('resize', onResize, { passive: true });
    onResize();
  }

  document.querySelectorAll('.gm-testimonials[id]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
